import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { LogoMark } from "@/components/Logo";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0B0F17] flex items-center justify-center px-5 noise-overlay grid-lines">
      <div className="glass-panel rounded-3xl p-10 max-w-md w-full text-center glow-border">
        <div className="flex justify-center mb-6">
          <LogoMark size={56} />
        </div>
        <XCircle size={44} className="mx-auto text-slate-500 mb-5" />
        <h1 className="text-2xl font-bold text-slate-50">Zahlung abgebrochen</h1>
        <p className="text-sm text-slate-400 mt-3">
          Kein Problem — dein Warenkorb bleibt gespeichert. Du kannst die Zahlung jederzeit fortsetzen.
        </p>
        <Link
          to="/"
          data-testid="payment-cancel-home-link"
          className="mt-8 inline-flex items-center justify-center rounded-full bg-gradient-to-r from-[#1E6FD9] to-[#29B6F6] px-7 py-3 text-sm font-bold text-white transition-transform duration-300 hover:scale-[1.03]"
        >
          Zurück zum Shop
        </Link>
      </div>
    </div>
  );
}
